import { render, staticRenderFns } from "./VideoCaptions.vue?vue&type=template&id=9d6ec398"
import script from "./VideoCaptions.vue?vue&type=script&lang=ts"
export * from "./VideoCaptions.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports